module.exports = __webpack_public_path__ + "img/submitPage1.055af5e8.png";